<div class="example-container" style="width: 100%;height:100px; background-color: var(--tdo-subnav-color);display: inline-flex;" data-cy="financial-snapshot-header">
  <div style="display: inline-block; width: 50%; padding-left: 10px" data-cy="financial-snapshot-header-left">
    <div style="display: inline-flex; margin-right: 5px" data-cy="financial-snapshot-logo-section">
      <div class="logo-area" data-cy="financial-snapshot-logo-area">
            <img class="logo-image" *ngIf="reportLogoDocument" [src]="getImageUrl('LogoReport_DocumentID', reportLogoDocument)" data-cy="financial-snapshot-logo" />
      </div>
      <div style="display: inline-block; width: 50%; padding-left: 10px" data-cy="financial-snapshot-practice-info">
        <div class="divTitle" data-cy="financial-snapshot-practice-name-container">
          <mat-label class="matLabel" data-cy="financial-snapshot-practice-name">{{ProviderPracticeName}}</mat-label>
        </div>
        <div class="divTitle" data-cy="financial-snapshot-address-top-container">
          <mat-label class="matLabel" data-cy="financial-snapshot-address-top">{{ProviderPracticeTopAddress}}</mat-label>
        </div>
        <div class="divTitle" data-cy="financial-snapshot-address-bottom-container">
          <mat-label class="matLabel" data-cy="financial-snapshot-address-bottom">{{ProviderPracticeBottomAddress}}</mat-label>
        </div>
      </div>
    </div>
    <div class="divTitle" data-cy="financial-snapshot-date-range-label-container">
      <mat-label class="matLabel" data-cy="financial-snapshot-date-range-label">Date Range: {{dateRange}}</mat-label>
    </div>
    <div class="divTitle" data-cy="financial-snapshot-date-range-container">
      <mat-label class="matLabel" data-cy="financial-snapshot-date-range">{{initialDate | date:'longDate' }} - {{endDateLabel}}</mat-label>
    </div>
    <div class="divTitle" data-cy="financial-snapshot-referring-practice-container">
      <mat-label class="matLabel" data-cy="financial-snapshot-referring-practice">Referring Practice: {{ProviderPracticeName}}</mat-label>
    </div>
  </div>
  <div style="display: inline-block; width: 50%; padding-right: 10px" data-cy="financial-snapshot-header-right">
    <div style="float: right; width: 100%" data-cy="financial-snapshot-tdo-logo-container">
          <img src="assets/Images/navbar-icons/v2/new_tdo_logo.svg" class="logo-image" style="display: inline-flex; float: right" data-cy="financial-snapshot-tdo-logo" />
    </div>
    <div style="float: right; width: 100%" data-cy="financial-snapshot-report-name-container">
      <mat-label style="float: right; display: inline-flex;font-size: x-small; font-weight: bold" data-cy="financial-snapshot-report-name">{{ReportName}}</mat-label>
    </div>
    <div style="float: right; width: 100%" data-cy="financial-snapshot-date-today-container">
      <mat-label style="float: right; display: inline-flex;font-size: x-small; font-weight: bold" data-cy="financial-snapshot-date-today">{{DateToday}}</mat-label>
    </div>
  </div>
</div>
<div class="example-container mat-elevation-z8" style="width: 100%;height: calc(100vh - 202px);overflow-x:scroll;overflow-y:scroll;" data-cy="financial-snapshot-content">
  <div class="main-container" *ngIf="!isLoading" data-cy="financial-snapshot-table-container">
  <table mat-table [dataSource]="dataSource" style="width: 100%; height: 100%" data-cy="financial-snapshot-table">

    <ng-container matColumnDef="label" sticky="true">
      <td mat-cell *matCellDef="let row" [ngClass]="{'myCSSclass' : row.label !== 'Gross Production' && row.label !== 'Collections' }" data-cy="financial-snapshot-cell-label">{{ row.label }}</td>
    </ng-container>

    <ng-container [matColumnDef]="'column' + i" *ngFor="let column of financialSnapshotDataSource; let i = index">
      <td mat-cell *matCellDef="let row" (click)="openDialog(row,row['column' + i],i)" [attr.isCurrency]=" row['column' + i].includes('$')? 'true' : 'false'" [attr.data-cy]="'financial-snapshot-cell-' + i"> {{ row['column' + i] }} </td>    
    </ng-container>
    <!--<tr mat-header-row *matHeaderRowDef="displayedDoctorColumns" [attr.role]="null"></tr>!-->
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'myCSSclassHide' : row.label === 'ID'}" [ngClass]="{'myCssGroupHeader' : row.label == 'Gross Production' || row.label == 'Collections'}" data-cy="financial-snapshot-row"></tr>
  </table>
</div>
  <div class="spinner-container" *ngIf="isLoading" data-cy="financial-snapshot-loading">
    <mat-spinner data-cy="financial-snapshot-spinner"></mat-spinner>
  </div>
</div>